import React from 'react';
import { Check, Gavel, Shield, Description, Payment, SupportAgent } from '@mui/icons-material';

const TermsAndConditionsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto p-4 sm:p-6 lg:p-8" dir="rtl">
        
        {/* Header Section */}
        <div className="mb-10 text-center">
          <div className="inline-flex items-center justify-center mb-4">
            <div className="bg-gradient-to-r from-primary to-primary-dark p-4 rounded-2xl shadow-lg">
              <Gavel className="text-white text-3xl" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            الشروط والأحكام – بازار ماركت بليس
          </h1>
          <div className="h-1.5 w-24 bg-gradient-to-r from-primary to-primary-dark mx-auto rounded-full mb-4"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            آخر تحديث: {new Date().toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Important Notice */}
        <div className="mb-8 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 border-r-4 border-primary rounded-xl">
          <div className="flex items-start gap-4">
            <Shield className="text-primary text-2xl mt-1 flex-shrink-0" />
            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">ملاحظة هامة</h3>
              <p className="text-gray-700 leading-relaxed">
                مرحبًا بك في بازار ماركت بليس. باستخدامك لمنصتنا (https://bazaar-marketplace.com)، 
                فإنك توافق على الشروط والأحكام التالية. هذه الشروط تنظم استخدامك للمنصة كبائع أو مشتري أو زائر. 
                الرجاء قراءتها بعناية قبل استخدام المنصة.
              </p>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {[
            {
              icon: <Description />,
              title: "١. طبيعة المنصة",
              items: [
                "منصة لعرض المنتجات للشركات والبائعين.",
                "تسهيل عمليات البيع والشراء.",
                "توفير سوق رقمي منظم وآمن وسهل الاستخدام مخصص للمستخدم المصري."
              ],
              note: "بازار ليس بائعًا مباشرًا أو منتجًا. بل هو أداة تكنولوجية لربط المستخدمين وتسهيل تجربة التجارة الإلكترونية."
            },
            {
              icon: <Check />,
              title: "٢. مسؤوليات البائعين",
              items: [
                "تحمل المسؤولية القانونية والحكومية الكاملة عن منتجاتهم وأعمالهم.",
                "التأكد من تحديث التراخيص والسجلات الضريبية والمستندات القانونية.",
                "تقديم المستندات المطلوبة قبل عرض المنتجات.",
                "الرد على استفسارات العملاء بسرعة ومهنية."
              ],
              note: "بازار غير مسؤول عن أي انتهاكات أو أخطاء قانونية في أوراق البائع."
            },
            {
              icon: <Check />,
              title: "٣. مسؤوليات المشتري",
              items: [
                "توفير معلومات دقيقة للتوصيل والتواصل.",
                "مراجعة ملفات البائعين ومؤشرات الثقة قبل الشراء.",
                "التواصل مع دعم العملاء لحل النزاعات أو الإرجاع."
              ]
            },
            {
              icon: <Shield />,
              title: "٤. توثيق المنتجات والثقة",
              items: [
                "التأكد من أن كل منتج معروض حقيقي ومتوفر.",
                "توثيق الشركات والبائعين قبل عرض المنتجات.",
                "تتبع الطلبات عبر شركات شحن موثوقة.",
                "تقديم دعم فوري وخدمات إرجاع."
              ]
            },
            {
              icon: <Description />,
              title: "٥. لوحة تحكم البائع والتحليلات",
              items: [
                "لوحة تحكم كاملة لإدارة المنتجات والطلبات والتواصل مع العملاء.",
                "تحليلات مباشرة للمبيعات.",
                "أدوات لإدارة الفروع المتعددة."
              ]
            },
            {
              icon: <Description />,
              title: "٦. التعديلات والتحديثات",
              items: [],
              note: "تحتفظ بازار بحق تعديل الشروط والأحكام في أي وقت. استمرار استخدام المنصة يعني موافقتك على أي تغييرات مستقبلية بما في ذلك التكامل مع فيسبوك وواتساب أو غيرها."
            },
            {
              icon: <Payment />,
              title: "٧. الضرائب",
              items: [
                "البائع مسؤول عن التزاماته الضريبية وفقًا للقانون المصري.",
                "بازار مسجلة برقم ضريبي 752-382-462.",
                "نمنع بشدة التهرب الضريبي."
              ]
            },
            {
              icon: <Gavel />,
              title: "٨. موافقة المستخدم والاعتراف القانوني",
              items: [
                "جميع المستخدمين يقرون بأنهم قد تم عرض هذه الشروط عليهم.",
                "لا يحق لأي طرف المطالبة بعدم قراءتها أو فهمها.",
                "تطبق القوانين المصرية للتجارة الإلكترونية على كافة العمليات."
              ]
            },
            {
              icon: <Shield />,
              title: "٩. تحديد المسؤولية",
              items: [
                "نحن غير مسؤولين عن مشاكل التوصيل أو منتجات البائعين.",
                "نقوم بالوساطة في النزاعات دون تمثيل قانوني.",
                "نحمي بياناتك ضمن منصتنا فقط."
              ]
            },
            {
              icon: <SupportAgent />,
              title: "١٠. التواصل والدعم",
              items: [],
              note: (
                <>
                  <p className="mb-2">البريد الإلكتروني: <a href="mailto:support@bazaar-marketplace.com" className="text-primary font-medium hover:underline">support@bazaar-marketplace.com</a></p>
                  <p className="mb-2">هاتف / واتساب: <a href="tel:+201503323006" className="text-primary font-medium hover:underline">+20 150 332 3006</a></p>
                  <p>مدعوم من: <strong className="text-primary">CODEOCEAN.TECH</strong></p>
                </>
              )
            }
          ].map((section, index) => (
            <section key={index} className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="bg-gradient-to-r from-primary/10 to-primary/20 p-3 rounded-lg">
                  <span className="text-primary text-xl">{section.icon}</span>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    {section.title}
                    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-primary/30 to-transparent"></span>
                  </h2>
                  
                  {section.items.length > 0 && (
                    <ul className="space-y-2 mb-4">
                      {section.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start gap-3">
                          <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                          <span className="text-gray-700 leading-relaxed">{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  
                  {section.note && (
                    <div className="mt-4 p-4 bg-gray-50 rounded-lg border-r-4 border-primary">
                      {typeof section.note === 'string' ? (
                        <p className="text-gray-700 leading-relaxed">{section.note}</p>
                      ) : (
                        section.note
                      )}
                    </div>
                  )}
                </div>
              </div>
            </section>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary/10 to-primary/20 px-6 py-3 rounded-full">
              <span className="text-primary font-bold">بازار ماركت بليس</span>
              <span className="text-gray-500">•</span>
              <span className="text-gray-600">رقم ضريبي: 752-382-462</span>
            </div>
          </div>
          
          <div className="text-gray-500 text-sm leading-relaxed max-w-2xl mx-auto">
            <p className="mb-4">
              شكرًا لانضمامك إلى بازار – السوق الرقمي الذي يعكس طموح الاقتصاد المصري.
            </p>
            <p className="text-gray-400">
              جميع الحقوق محفوظة © {new Date().getFullYear()} بازار ماركت بليس
            </p>
          </div>

          {/* Back to top */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="mt-6 px-6 py-2 bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg hover:opacity-90 transition-opacity duration-300"
          >
            العودة للأعلى
          </button>
        </div>

        {/* Legal Notice */}
        <div className="mt-8 p-4 bg-gray-50 rounded-lg text-center text-sm text-gray-500">
          <p>
            هذه الوثيقة قانونية وملزمة. يرجى الاحتفاظ بنسخة منها.
            <br />
            للتأكد من أنك تقرأ النسخة الأحدث، قم بزيارة: 
            <a href="https://bazaar-marketplace.com/terms-conditions" className="text-primary font-medium mx-1 hover:underline">
              https://bazaar-marketplace.com/terms-conditions
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;